import { render, staticRenderFns } from "./AdminShowPdfDialog.vue?vue&type=template&id=2ebdb59a&scoped=true&"
import script from "./AdminShowPdfDialog.vue?vue&type=script&lang=js&"
export * from "./AdminShowPdfDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebdb59a",
  null
  
)

export default component.exports